import { useSelector } from 'react-redux';

import * as dealModeSelectors from '@makemydeal/dr-dash-store/selectors/dealModeSelectors';
import { ContainerGrid, ContainerGridItem } from '@makemydeal/dr-dash-components';

import { REQUIRED } from '../../constants';

export const ManualRebatesFormHeader = () => {
    const isOptionalDeskingMode = useSelector(dealModeSelectors.isOptionalDeskingMode);

    return (
        <ContainerGrid style={{ borderBottom: '2px solid #003468', color: '#003468', fontWeight: 700, paddingRight: '50px' }}>
            <ContainerGridItem xs="hidden" md={2}>
                <p>Program #</p>
            </ContainerGridItem>
            <ContainerGridItem xs="hidden" md={3}>
                <p>Incentive Name ({REQUIRED})</p>
            </ContainerGridItem>
            <ContainerGridItem xs="hidden" md={2}>
                <p>Code</p>
            </ContainerGridItem>
            <ContainerGridItem xs="hidden" md={3}>
                <p>Type{isOptionalDeskingMode ? '' : ` (${REQUIRED})`}</p>
            </ContainerGridItem>
            <ContainerGridItem xs="hidden" md={2}>
                <p>Amount</p>
            </ContainerGridItem>
        </ContainerGrid>
    );
};
